import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackGaPageView } from '@/lib/analytics/ga';

/** SPA pageviews for GA4. Must sit inside BrowserRouter. */
export function GaPageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackGaPageView(pathname);
  }, [pathname]);

  return null;
}
